import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, OutlinedInput, Typography, useMediaQuery } from '@mui/material';
import Modal from '@mui/material/Modal';
import { useFormik } from 'formik';
import React from 'react';
import { sxFormError, sxLabel } from '../../assets/styles/CommonSxProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import DefaultButton from '../Accessibility/DefaultButton';
import WhiteContainer from '../Accessibility/WhiteContainer';
import './styles.css';
import { sxButton, sxButtonContained, sxInputNumberModal, sxTypographyTitle } from './sxProps';


const ModalNewPhone: React.FC<{
  showModal: boolean,
  handleShowModal: () => void,
  handleChangeNumber: () => void
}> = ({ showModal, handleShowModal, handleChangeNumber }) => {

  const { textStyleAccessibility } = useAccessibility();

  const mobileScreen = useMediaQuery('(max-width: 899px)');

  const formik = useFormik({
    initialValues: {
      numeroAtual: '',
      novoNumero: ''
    },
    // validationSchema: NovoNumeroValidation,
    onSubmit: (values) => {
      console.log(values)
      formik.resetForm();
    },
    validateOnChange: false
  });

  const closeModal = () => {
    handleShowModal();
    formik.resetForm();
  }

  const containedButton = (
    <DefaultButton
      type='submit'
      sx={sxButtonContained}
      text='Salvar'
      variant={'contained'}
    />
  );

  const outlinedButton = (
    <DefaultButton
      onClick={closeModal}
      sx={sxButton}
      text='Cancelar'
      variant={'outlined'}
    />
  );


  return (
    <div>
      {showModal && <Modal
        open={showModal}
        onClose={closeModal}
      >
        <form onSubmit={formik.handleSubmit}>
          <WhiteContainer className='container-modal-new-number'>
            <div className='modal-new-number-header'>
              <Typography style={textStyleAccessibility} tabIndex={0} sx={sxTypographyTitle}>Escolher outro número</Typography>
              <IconButton
                aria-label="close"
                onClick={closeModal}
              >
                <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
              </IconButton>
            </div>
            <Box display={'flex'} flexDirection={'column'} width={'100%'} >
              <Typography style={textStyleAccessibility} sx={sxLabel}>Número atual</Typography>
              <label htmlFor='numeroAtual' aria-label='numeroAtual' />
              <OutlinedInput
                placeholder='(11) 99999-9999'
                id='numeroAtual'
                type={'text'}
                value={formik.values.numeroAtual}
                onChange={(e) => { formik.setFieldValue('numeroAtual', e.target.value); }}
                name='numeroAtual'
                style={textStyleAccessibility}
                error={!!formik.errors.numeroAtual}
                maxRows={1}
                inputProps={{ maxLength: 15 }}
                sx={sxInputNumberModal}
              />
              <Typography style={textStyleAccessibility} sx={sxFormError}>{formik.errors.numeroAtual}</Typography>
            </Box>
            <Box display={'flex'} flexDirection={'column'} width={'100%'} >
              <Typography style={textStyleAccessibility} sx={sxLabel}>Novo número</Typography>
              <label htmlFor='novoNumero' aria-label='novoNumero' />
              <OutlinedInput
                placeholder='(11) 99999-9999'
                id='novoNumero'
                type={'text'}
                value={formik.values.novoNumero}
                onChange={(e) => { formik.setFieldValue('novoNumero', e.target.value); }}
                name='novoNumero'
                style={textStyleAccessibility}
                error={!!formik.errors.novoNumero}
                maxRows={1}
                inputProps={{ maxLength: 15 }}
                sx={sxInputNumberModal}
              />
              <Typography style={textStyleAccessibility} sx={sxFormError}>{formik.errors.novoNumero}</Typography>
            </Box>
            <div className='number-modal-buttons-holder'>
              {mobileScreen ? containedButton : outlinedButton}
              {mobileScreen ? outlinedButton : containedButton}
            </div>
          </WhiteContainer>
        </form>
      </Modal>}
    </div>
  );
};

export default ModalNewPhone;
